import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconShield"><Path d="M12.5534 2.14352C12.1942 2.02378 11.8058 2.02378 11.4466 2.14352L4.1966 4.56018C3.482 4.79838 3 5.46713 3 6.22038V11.912C3 14.6493 4.18351 16.6697 5.85876 18.2593C7.5058 19.8221 9.65956 20.9971 11.6439 22.0676C11.8662 22.1875 12.1338 22.1875 12.3561 22.0676C14.3404 20.9971 16.4942 19.8221 18.1412 18.2593C19.8165 16.6697 21 14.6493 21 11.912V6.22038C21 5.46712 20.518 4.79838 19.8034 4.56018L12.5534 2.14352Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield;
